import React from 'react';

const CardPolizaAccion = ({ poliza, cliente, onAction, actionLabel, colorTheme = 'blue' }) => {
    if (!poliza || !cliente) return null;

    const themeClasses = {
        blue: { bg: 'bg-blue-50', border: 'border-blue-100', textTitle: 'text-blue-900', textSub: 'text-blue-700', btn: 'bg-blue-600 hover:bg-blue-700' },
        red: { bg: 'bg-red-50', border: 'border-red-100', textTitle: 'text-red-900', textSub: 'text-red-700', btn: 'bg-red-600 hover:bg-red-700' },
        green: { bg: 'bg-green-50', border: 'border-green-100', textTitle: 'text-green-900', textSub: 'text-green-700', btn: 'bg-green-600 hover:bg-green-700' },
        orange: { bg: 'bg-orange-50', border: 'border-orange-100', textTitle: 'text-orange-900', textSub: 'text-orange-700', btn: 'bg-orange-600 hover:bg-orange-700' },
    };
    const theme = themeClasses[colorTheme] || themeClasses.blue;

    return (
        <div className={`max-w-2xl mt-6 rounded-xl p-6 animate-fade-in border ${theme.bg} ${theme.border}`}>
            <div className="flex justify-between items-start mb-4">
                <div>
                    <h3 className={`text-lg font-bold ${theme.textTitle}`}>{cliente.nombre} {cliente.apellido}</h3>
                    <p className={`text-sm ${theme.textSub}`}>{cliente.dni || cliente.cuit}</p>
                </div>
                <span className={`bg-white px-3 py-1 rounded-full text-xs font-bold border uppercase ${theme.textSub} ${theme.border}`}>
                    {poliza.estadoEmision}
                </span>
            </div>
            
            <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 mb-6">
                <div>
                    <span className="block font-bold text-gray-400 text-xs uppercase">Compañía</span>
                    <span className="font-semibold text-gray-800">{poliza.compania}</span>
                </div>
                <div>
                    <span className="block font-bold text-gray-400 text-xs uppercase">Riesgo</span>
                    <span className="font-semibold text-gray-800">{poliza.riesgo}</span>
                </div>
                <div>
                    <span className="block font-bold text-gray-400 text-xs uppercase">Póliza</span>
                    <span className="font-mono font-bold text-gray-800">{poliza.nPoliza}</span>
                </div>
                {poliza.patente && (
                    <div>
                        <span className="block font-bold text-gray-400 text-xs uppercase">Patente</span>
                        <span className="font-mono font-bold text-gray-800 bg-white px-2 rounded border border-gray-200">{poliza.patente}</span>
                    </div>
                )}
            </div>

            <button 
                onClick={onAction}
                className={`w-full text-white font-bold py-3 rounded-xl shadow-lg transition-transform transform hover:scale-[1.02] ${theme.btn}`}
            >
                {actionLabel || 'Continuar'}
            </button>
        </div>
    );
};

export default CardPolizaAccion;